import { BaseAddress, IBaseAddress } from "@/types/BaseAddress";

export interface IClaim extends IBaseAddress {
  claim_type_name: string;
  policy_id: string;
  risk_id: number;
  policy_risk_id: string;
  type: string;
  claim_incurred: number;

  cover_holder: "";
}
export class Claim extends BaseAddress {
  get coverHolder(): string {
    return "cover_holder" in this._data ? this._data.cover_holder : "";
  }

  get riskType() {
    return "type" in this._data ? this._data.type : "";
  }

  get claimType() {
    return "claim_type_name" in this._data ? this._data.claim_type_name : "";
  }

  get policyRiskId(): string {
    return "policy_risk_id" in this._data
      ? this._data.policy_risk_id
      : this.policyId && this.riskId
      ? `${this.policyId}#${this.riskId}`
      : "";
  }

  get policyId() {
    return "policy_id" in this._data ? this._data.policy_id : "";
  }

  get riskId() {
    return "risk_id" in this._data ? this._data.risk_id : "";
  }

  get claimIncurred() {
    return "claim_incurred" in this._data ? this._data.claim_incurred : 0;
  }
}
